import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import authReducer from "./authSlice";
import conventionReducer from "./conventionSlice";
import conventionsReducer from "./conventionsSlice";
import liveConventionsReducer from "./liveConventions";
import modalReducer from "./modalSlice";
import selfServiceReducer from "./selfServiceSlice";
import wishlistReducer from "./wishlistSlice";

// CONSTANTS ------------------------------------------------------------------

const customMiddleware = [];
const { REACT_APP_NODE_ENV } = process.env;
const isProd = REACT_APP_NODE_ENV !== "develop";
const logger = createLogger({});
if (!isProd) {
  customMiddleware.push(logger);
}

// MAIN -----------------------------------------------------------------------

/**
 * @desc Store entry point.
 */
export default configureStore({
  reducer: {
    auth: authReducer,
    convention: conventionReducer,
    conventions: conventionsReducer,
    liveConventions: liveConventionsReducer,
    modal: modalReducer,
    selfService: selfServiceReducer,
    wishlist: wishlistReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(customMiddleware),
});
